import { z } from "zod";
import { adminOperatorIdSchema } from "./admin-operations-core.js";
import { adminSupportWorkspaceSchemaVersionSchema } from "./admin-operations-support-workspace.js";
/**
 * Who can take a shared Support request (I3.2, 2026-10-28): the active owners and Support
 * teammates a request may be handed to, so the approved "Hand this request to" list and the
 * "Handled by" line show people instead of raw operator ids.
 *
 * The operator registry holds no names, and Support staff are not shown teammates' sign-in
 * emails anywhere else, so each person is named by a stable, non-identifying label derived from
 * their opaque operator id ("Teammate 3F9A2C"). No email, sign-in state or access history is
 * returned.
 */
export const adminSupportTeammatesCommandSchema = z.object({}).strict();
export const adminSupportTeammateRoleSchema = z.enum(["ADMIN", "SUPPORT_AGENT"]);
export const adminSupportTeammateSchema = z
    .object({
    operatorId: adminOperatorIdSchema,
    displayName: z.string().min(1).max(40),
    role: adminSupportTeammateRoleSchema,
    nameVersion: z.number().int().nonnegative().optional(),
    nameVerified: z.boolean().optional(),
})
    .strict();
export const adminSupportTeammatesResponseSchema = z
    .object({
    data: z
        .object({
        schemaVersion: adminSupportWorkspaceSchemaVersionSchema,
        teammates: z.array(adminSupportTeammateSchema).max(200),
        /** More operators exist than one read returns: the list may be missing someone. */
        truncated: z.boolean(),
    })
        .strict(),
})
    .strict();
/** The label both the server and the console use for an operator id (never an email). */
export function supportTeammateDisplayName(operatorId) {
    const tail = operatorId
        .replaceAll(/[^A-Za-z0-9]/gu, "")
        .slice(-6)
        .toUpperCase();
    return tail ? `Teammate ${tail}` : "Teammate";
}
//# sourceMappingURL=admin-operations-support-teammates.js.map